import EventEmitter from 'eventemitter3'

// Export singleton of tiny emitter

const emitter = new EventEmitter()
window.emitterDebug = emitter;
export default emitter;
